<script setup lang="ts">
import HeaderDefault from "./header/index.vue";
import MenuDefault from "./menu/index.vue";
</script>

<template>
    <div class="app-container">
        <HeaderDefault />
        <main class="container">
            <MenuDefault v-if="!$route.meta.hideMenu" />
            <el-row class="row">
                <router-view />
            </el-row>
        </main>
    </div>
</template>

<style scoped lang="scss">
.app-container {
    min-width: 1440px;
    height: 100vh;
    box-sizing: border-box;
    background: var(--fef-7-d-2-ffffff-100, linear-gradient(180deg, #f0f6ff 0%, #fafbfc 49.5%));
    .container {
        width: 100%;
        height: calc(100% - 60px);
        display: flex;
        padding: 16px;
        box-sizing: border-box;
        .row {
            flex: 1;
            margin-left: 16px;
            display: flex;
            justify-content: center;
            align-content: flex-start;
            overflow-y: auto;
            :deep {
                & > .detail-container {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }
            }
        }
    }
}

@media (min-width: 1440px) {
    .app-container {
        width: 100%;
        overflow-x: hidden;
    }
}
</style>
